/* eslint-disable @typescript-eslint/no-explicit-any */
// Different classes, including abstract.
type Class<T> = (new (...args: any[]) => T) | any;
/* eslint-enable @typescript-eslint/no-explicit-any */

export default function <DestinationClass, SourceClass>(
  destinationClass: Class<DestinationClass>,
  sourceClass: Class<SourceClass>,
  properties: string[]
) {
  properties.forEach((property) => {
    destinationClass.prototype[property] = sourceClass.prototype[property];
  });
}
